
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["pause2_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M418.857 283.429c8.229 0 14.972 4.114 14.972 9.142V731.43c0 5.028-6.743 9.142-14.972 9.142h-52.343c-8.228 0-14.971-4.114-14.971-9.142V292.57c0-5.028 6.743-9.142 14.971-9.142zm238.629 0c8.228 0 14.971 4.114 14.971 9.142V731.43c0 5.028-6.743 9.142-14.971 9.142h-52.343c-8.229 0-14.972-4.114-14.972-9.142V292.57c0-5.028 6.743-9.142 14.972-9.142zM512 0C229.257 0 0 229.257 0 512s229.257 512 512 512 512-229.257 512-512S794.743 0 512 0z","fill":"#dbdbdb"}})])
          )
        }
      }
    